import React, { useRef } from 'react'
import DatePicker, { registerLocale } from 'react-datepicker'
import es from 'date-fns/locale/es'
import { getDateRange } from '../../../helpers/style_string.helper'
import 'react-datepicker/dist/react-datepicker.css'

registerLocale('es', es)

function RangeDatePicker ({ dateRange, setDateRange, setDates, loadingData }) {
  const [startDate, endDate] = dateRange
  // Last complete range, so closing the calendar halfway through a selection
  // puts back what the report is actually showing instead of a half range.
  const lastCompleteRange = useRef(dateRange)
  if (startDate && endDate) lastCompleteRange.current = dateRange

  return (
    <DatePicker
      selectsRange
      dateFormat='dd/MM/yyyy'
      className='form-control date-picker'
      startDate={startDate}
      endDate={endDate}
      maxDate={new Date()}
      onChange={(date) => {
        setDateRange(date)
        const [start, end] = date
        if (!start || !end) return
        lastCompleteRange.current = date
        setDates(getDateRange(start, end))
        loadingData.current = false
      }}
      onCalendarClose={() => {
        const [start, end] = dateRange
        if (!start || !end) setDateRange(lastCompleteRange.current)
      }}
      locale='es'
    />
  )
}

export default RangeDatePicker
